import * as types from './mutation-types';

const getInit = () => {
	return {
		searchParams: {
			comm: {
				lineCd: '',
				ref1Cd: '',
				ref2Cd: '',
				ref3Cd: '',
				ref4Cd: '',
				ref5Cd: '',
				ref6Cd: ''
			}
		},
		factoryList: [],
		/**factory 필터되지 않은 전체 리스트 */
		lineList: [],
		/**factory 필터된 전체 리스트 */
		lineFilteredList: [] /**factory 필터된 전체 리스트 */,

		/**tab open 연동 테스트 데이터 */
		gqmsSeq: '',
		resultFileList: [],
		resultObj: {}
	};
};
export default {
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit());
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.FACTORY_LIST]: (state, { key, value }) => {
		state.factoryList[key] = value;
	},
	[types.LINE_LIST]: (state, { key, value }) => {
		state.lineList[key] = value;
	},
	[types.COMM_CODE]: (state, { key, value }) => {
		state.searchParams.comm[key] = value;
	}
};
